<template>
  <tab-layout :full-width="true">
    <div slot="tabContent" class="bg-white rounded mb-4 p-3">
      <page-heading>Send bulk email/text</page-heading>

      <form @submit.prevent="handleSend">
        <div class="row mb-3">
          <div class="col-12 col-md-6 mb-3 mb-md-0">
            <f-search-select
              id="bulk-send-type"
              label="Send Type"
              :options="sendTypes"
              option-label="label"
              v-model="form.sendType"
            />
          </div>
          <div class="col-12 col-md-6">
            <f-search-select
              id="bulk-send-to"
              label="Send To"
              :options="recipients"
              option-label="label"
              v-model="form.sendTo"
            />
          </div>
        </div>

        <div class="mb-3">
          <f-textarea
            id="bulk-text"
            label="Text"
            v-model="form.text"
            :rows="6"
            required
            placeholder="Enter your message..."
          />
        </div>

        <app-button variant="primary" :block="false" type="submit" :loading="sending">Send</app-button>
      </form>
    </div>
  </tab-layout>
</template>

<script>
import { defineComponent, reactive, computed, getCurrentInstance, onMounted } from '@vue/composition-api'
import TabLayout from '@/components/TabLayout'
import PageHeading from '@/components/PageHeading'
import AppButton from '@/components/AppButton'
import FSearchSelect from '@/components/FormFields/FSearchSelect'
import FTextarea from '@/components/FormFields/FTextarea'
import useNominationsBulkEmail from '@/composables/nominations/useNominationsBulkEmail'

export default defineComponent({
  name: 'NominationsBulkEmail',
  components: { TabLayout, PageHeading, AppButton, FSearchSelect, FTextarea },
  setup() {
    const { proxy } = getCurrentInstance()
    const draftId = computed(() => proxy.$route.params.draftId)
    const bulkEmail = useNominationsBulkEmail(draftId.value)

    const form = reactive({
      sendType: null,
      sendTo: null,
      text: ''
    })

    async function handleSend() {
      if (form.sendType == null || form.sendTo == null || !form.text) return
      const result = await bulkEmail.send({
        send_type: form.sendType,
        send_to: form.sendTo,
        bulk_text: form.text
      })
      if (result != null) {
        form.sendType = null
        form.sendTo = null
        form.text = ''
      }
    }

    onMounted(() => {
      bulkEmail.fetchOptions()
    })

    return {
      form,
      sendTypes: bulkEmail.sendTypes,
      recipients: bulkEmail.recipients,
      sending: bulkEmail.sending,
      handleSend
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/Nominations/BulkEmail/NominationsBulkEmail.vue